<template>
  <div class="gc-info-wrap">
    <van-nav-bar
      :border="false"
      :title="title"
      left-arrow
      @click-left="$router.back()"
    />
    <div class="page-info-wrap">
      <div class="item">
        <span>项目名称</span>
        <input
          class="input"
          v-model="proName"
          type="text"
          placeholder="请输入"
        />
      </div>
      <div class="item arr" @click="showType = true">
        <span>项目类型</span>
        {{ proType }}
      </div>
      <div class="item">
        <span>项目金额（元）</span>
        <input
          class="input"
          v-model="proMoney"
          type="number"
          placeholder="请输入"
        />
      </div>
      <div class="item arr" @click="showTag = true">
        <span>项目标签</span>
        {{ tag }}
      </div>
      <div class="item arr" @click="showStartTime = true">
        <span>计划开始时间</span>
        {{ startDate }}
      </div>
      <div class="item arr" @click="showEndTime = true">
        <span>预计交付时间</span>
        {{ endDate }}
      </div>
      <div class="item" style="display:block">
        <span>项目描述</span>
        <textarea
          class="textarea"
          v-model="proDesc"
          placeholder="请输入"
        ></textarea>
      </div>
      <!-- <div class="item arr" @click="showDep=true">
               <span>参与部门</span>
                <div style="max-width: 60%;min-width:0">
                    <div v-if="activeName.length>0" style="display:flex;flex-wrap:wrap">
                        <p v-for="(item,index) in activeName" :key="index">&emsp;{{item.name}}</p>
                    </div>
                    <p v-else>请选择</p>
                </div>
           </div>   -->
    </div>
    <div class="gc-page-project-wrap">
      <div class="page-dep-wrap box">
        <div class="item arr" @click="showMemberOne = true">
          <span>验收人员：</span>
          {{ activeNameOne }}
        </div>
      </div>
      <div class="page-dep-wrap box">
        <div class="item arr" @click="showMoney">
          <span>出资类型</span>
          {{ columnsMoneyType[moneyType] }}
        </div>
        <div class="item arr" v-if="moneyType == 1" @click="onshowMembers">
          <span>出资人员：</span>
          请选择
        </div>
        <div
          class="page-member-wrap"
          v-if="activeNames.length > 0 && moneyType == 1"
        >
          <div class="title">
            <span class="s1">已选出资人员</span>
            <span class="s2">权重</span>
            <span class="s2">金额</span>
          </div>
          <div class="info-wrap">
            <div
              class="info-item"
              v-for="(item, index) in activeNames"
              :key="index"
            >
              <span class="s1"
                >{{ item.dep }}{{ item.dep ? "-" : "" }}{{ item.name }}</span
              >
              <span class="s2">
                <div class="input-wrap">
                  <!-- <input type="number" v-model="item.scale" class="input" @keyup="item.scale>100?item.scale=100:''"><i>%</i>  -->
                  <div class="input" @click="showWeightPicker(index, 'money')">
                    {{ item.scale ? item.scale : "请选择" }}<i>%</i>
                  </div>
                </div>
              </span>
              <span class="s2">{{
                Number((item.scale / 100) * proMoney).toFixed(2)
              }}</span>
            </div>
            <!-- <div class="info-item">
                            <span class="s1">合计</span>
                            <span class="s2">{{allWeight}}%</span>
                            <span class="s2"></span>
                        </div>   -->
            <div class="average-wrap">
              <div
                class="average-btn"
                @click="handleAverage(activeNames, tempActiveNames)"
              >
                平均分配
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 参与人员 -->
      <div class="page-dep-wrap box">
        <div class="item arr" @click="onshowJoinMembers">
          <span>收益人员：</span>
          请选择
        </div>
        <div class="page-member-wrap" v-if="activeJoinNames.length > 0">
          <div class="title">
            <span class="s1">已选收益人员</span>
            <span class="s2">权重</span>
            <span class="s2">金额</span>
          </div>
          <div class="info-wrap">
            <div
              class="info-item"
              v-for="(item, index) in activeJoinNames"
              :key="index"
            >
              <span class="s1"
                >{{ item.dep }}{{ item.dep ? "-" : "" }}{{ item.name }}</span
              >
              <span class="s2">
                <div class="input-wrap">
                  <div class="input" @click="showWeightPicker(index, 'join')">
                    {{ item.scale ? item.scale : "请选择" }}<i>%</i>
                  </div>
                </div>
              </span>
              <span class="s2">{{
                Number((item.scale / 100) * proMoney).toFixed(2)
              }}</span>
            </div>
            <div class="average-wrap">
              <div
                class="average-btn"
                @click="handleAverage(activeJoinNames, tempActiveJoinNames)"
              >
                平均分配
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="submit-btn" @click="handleCreatePro">提 交</div>

    <van-popup v-model="showType" position="bottom">
      <van-picker
        show-toolbar
        :columns="columnsType"
        :default-index="$route.query.type"
        @confirm="onConfirmType"
        @cancel="showType = false"
      />
    </van-popup>
    <van-popup v-model="showTag" position="bottom">
      <van-picker
        show-toolbar
        :columns="columnsTag"
        @confirm="onConfirmTag"
        @cancel="showTag = false"
      />
    </van-popup>
    <van-popup v-model="showStartTime" position="bottom">
      <van-datetime-picker
        type="date"
        title="计划开始时间"
        v-model="currentStartDate"
        @confirm="onConfirmStartTime"
        @cancel="showStartTime = false"
      />
    </van-popup>
    <van-popup v-model="showEndTime" position="bottom">
      <van-datetime-picker
        type="date"
        title="预计交付时间"
        v-model="currentEndDate"
        @confirm="onConfirmEndTime"
        @cancel="showEndTime = false"
      />
    </van-popup>
    <!-- 参与部门 -->
    <!-- <van-popup v-model="showDep" @close="handleCloseDep" position="bottom" >
            <van-tree-select
            :items="items"
            :active-id.sync="activeIds"
            :main-active-index.sync="activeIndex"
            />
        </van-popup> -->

    <!-- 验收人员 -->
    <van-popup
      v-model="showMemberOne"
      position="bottom"
      :style="{ height: '60%' }"
    >
      <div class="warp">
        <div class="opt-btn">
          <div class="cancel" @click="showMemberOne = false">取消</div>
          <div class="sure" @click="showMemberOne = false">确定</div>
        </div>
        <!-- <van-tree-select
                :items="items"
                :active-id.sync="activeId"
                :main-active-index.sync="activeIndexOne"
                @click-item="handleTree"
                /> -->
        <div class="popupbottom">
          <div class="popupbottom-left">
            <div
              :class="tableftindex == index ? 'active' : 'popupbottom-tab'"
              @click="onpersonnellist(index)"
              v-for="(item, index) in personnellist"
              :key="index"
            >
              {{ item.UserDepNameF }}
            </div>
          </div>
          <div class="popupbottom-right">
            <div class="popupbottom-tab2">
              <div
                :class="toptabindex == -1 ? 'active' : 'tab2-center'"
                @click="onDItemList(-1)"
              >
                全部
              </div>
              <div
                :class="toptabindex == index ? 'active' : 'tab2-center'"
                @click="onDItemList(index)"
                v-for="(items, index) in DItemList"
                :key="index"
              >
                {{ items.UserDepNameT }}
              </div>
            </div>
            <div class="popupbottom-list">
              <div
                :class="activeId == item.UserSysno ? 'active' : ''"
                @click="onUserName(item, index)"
                v-for="(item, index) in UItemList"
                :key="index"
              >
                {{ item.UserName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 出资人员 -->
    <van-popup
      v-model="showMembers"
      @close="handleClose"
      position="bottom"
      :style="{ height: '60%' }"
    >
      <div class="warp">
        <div class="opt-btn">
          <div class="cancel" @click="showMembers = false">取消</div>
          <div class="sure" @click="showMembers = false">确定</div>
        </div>
        <!-- <van-notice-bar left-icon="volume-o" text="切换检索条件会清除原检索条下所选的人员信息！" />
            <div style="margin-top: .3rem">
                <van-tabs v-model:active="activeUnit" type="card" :before-change="onClickTab">
                    <van-tab title="按部门检索">
                        <van-tree-select :items="items" :active-id.sync="activeIds" :main-active-index.sync="activeIndex" />
                    </van-tab>
                    <van-tab title="按事业部检索">
                        <van-tree-select :items="itemsUnit" :active-id.sync="activeIds"
                            :main-active-index.sync="activeIndex" />
                    </van-tab>
                </van-tabs>
            </div> -->
        <div class="popupbottom">
          <div class="popupbottom-left">
            <div
              :class="tableftindex == index ? 'active' : 'popupbottom-tab'"
              @click="onpersonnellist(index)"
              v-for="(item, index) in personnellist"
              :key="index"
            >
              {{ item.UserDepNameF }}
            </div>
          </div>
          <div class="popupbottom-right">
            <div class="popupbottom-tab2">
              <div
                :class="toptabindex == -1 ? 'active' : 'tab2-center'"
                @click="onDItemList(-1)"
              >
                全部
              </div>
              <div
                :class="toptabindex == index ? 'active' : 'tab2-center'"
                @click="onDItemList(index)"
                v-for="(items, index) in DItemList"
                :key="index"
              >
                {{ items.UserDepNameT }}
              </div>
            </div>
            <div class="popupbottom-list">
              <div
                :class="item.flag ? 'active' : ''"
                @click="onUserName1(item, index)"
                v-for="(item, index) in UItemList"
                :key="index"
              >
                {{ item.UserName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 出资类型 -->
    <van-popup v-model="showMoneyType" position="bottom">
      <van-picker
        show-toolbar
        :columns="columnsMoneyType"
        @confirm="onConfirmMoneyType"
        @cancel="showMoneyType = false"
        :default-index="moneyType"
      />
    </van-popup>
    <!-- 选择权重 -->
    <van-popup v-model="showWeight" position="bottom">
      <van-picker
        ref="weight"
        show-toolbar
        :columns="columnsWeight"
        @confirm="onConfirmWeight"
        @cancel="showWeight = false"
      />
    </van-popup>
    <!-- 参与人员 -->
    <van-popup
      v-model="showJoinMembers"
      @close="handleJoinClose"
      position="bottom"
      :style="{ height: '60%' }"
    >
      <div class="warp">
        <div class="opt-btn">
          <div class="cancel" @click="showJoinMembers = false">取消</div>
          <div class="sure" @click="showJoinMembers = false">确定</div>
        </div>
        <!-- <van-notice-bar left-icon="volume-o" text="切换检索条件会清除原检索条下所选的人员信息！" />
            <div style="margin-top: .3rem">
                <van-tabs v-model:active="activeUnit2" type="card" :before-change="onClickTab2">
                    <van-tab title="按部门检索">
                        <van-tree-select :items="items" :active-id.sync="activeJoinIds"
                            :main-active-index.sync="activeJoinIndex" />
                    </van-tab>
                    <van-tab title="按事业部检索">
                        <van-tree-select :items="itemsUnit" :active-id.sync="activeJoinIds"
                            :main-active-index.sync="activeJoinIndex" />
                    </van-tab>
                </van-tabs>
            </div> -->

        <div class="popupbottom">
          <div class="popupbottom-left">
            <div
              :class="tableftindex == index ? 'active' : 'popupbottom-tab'"
              @click="onpersonnellist(index)"
              v-for="(item, index) in personnellist"
              :key="index"
            >
              {{ item.UserDepNameF }}
            </div>
          </div>
          <div class="popupbottom-right">
            <div class="popupbottom-tab2">
              <div
                :class="toptabindex == -1 ? 'active' : 'tab2-center'"
                @click="onDItemList(-1)"
              >
                全部
              </div>
              <div
                :class="toptabindex == index ? 'active' : 'tab2-center'"
                @click="onDItemList(index)"
                v-for="(items, index) in DItemList"
                :key="index"
              >
                {{ items.UserDepNameT }}
              </div>
            </div>
            <div class="popupbottom-list">
              <div
                :class="item.isflag ? 'active' : ''"
                @click="onUserName2(item, index)"
                v-for="(item, index) in UItemList"
                :key="index"
              >
                {{ item.UserName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      proName: "",
      proMoney: "",
      proNeddNum: "",
      proDesc: "",
      tag: "请选择",
      startDate: "请选择",
      endDate: "请选择",
      proType: "请选择",

      columnsType: ["月计划", "临时计划"],
      columnsTag: ["内部", "外部"],
      showDep: false,
      showType: false,
      showTag: false,
      showStartTime: false,
      showEndTime: false,
      // minDate: '',
      // items:[{children: []}],
      // activeIndex: 0,
      // activeName: [],
      activeUnit: 0,
      activeUnit2: 0,
      showMembers: false,
      showJoinMembers: false,
      showMemberOne: false,
      showMoneyType: false,
      moneyType: 1,
      columnsMoneyType: ["全体人员", "部分人员", "外部项目"],
      items: [],
      itemsUnit: [],
      activeId: "",
      activeIds: [],
      activeJoinIds: [],
      activeNameOne: "请选择",
      activeNames: [],
      activeJoinNames: [],
      tempActiveNames: [],
      tempActiveJoinNames: [],
      activeIndexOne: 0,
      activeIndex: 0,
      activeJoinIndex: 0,
      dis: "",
      // 权重
      showWeight: false,
      showWeightType: "",
      weightActiveIndex: 0,
      weightJoinActiveIndex: 0,
      columnsWeight: [],

      title: "创建项目",
      currentStartDate: new Date(),
      currentEndDate: new Date(),

      // 人员组织架构调整新列表
      personnellist: [],
      DItemList: [],
      UItemList: [],
      tableftindex: 0,
      toptabindex: -1
    };
  },
  mounted() {
    this.WebGetNewUserInfo();
    // this.WebGetBDepInfo()
    // 获取事业部列表
    // this.WebGetUnitInfo()
    this.proType = this.$route.query.type == 0 ? "月计划" : "临时计划";

    if (this.$route.query.sysno) {
      // 详情
      this.WebGetDealProjectInfoEx(this.$route.query.sysno);
      this.title = "修改项目";
    }
    for (let i = 1; i <= 100; i++) {
      this.columnsWeight.push(i);
    }
  },
  methods: {
    handleCreatePro() {
      if (!this.proName) {
        this.$toast("请输入项目名称");
        return;
      }
      if (this.proType == "请选择") {
        this.$toast("请选择项目类型");
        return;
      }
      if (!this.proMoney) {
        this.$toast("请输入项目金额");
        return;
      }
      if (this.tag == "请选择") {
        this.$toast("请选择项目标签");
        return;
      }
      if (this.startDate == "请选择") {
        this.$toast("请选择项目计划开始时间");
        return;
      }
      if (this.endDate == "请选择") {
        this.$toast("请选择项目计划交付时间");
        return;
      }
      // if(this.activeName.length==0){
      //     this.$toast('请选择项目参与部门')
      //     return
      // }
      if (this.activeId == "") {
        this.$toast("请选择验收人员");
        return;
      }
      if (this.moneyType == 1) {
        if (this.activeNames.length == 0) {
          this.$toast("请选择出资人员");
          return;
        }
        let percent = 0;
        for (let obj of this.activeNames) {
          percent += Number(obj.scale);
        }
        if (percent != 100) {
          this.$toast("出资权重和一定要等于100");
          return;
        }
      }

      if (this.activeJoinNames.length == 0) {
        this.$toast("请选择收益人员");
        return;
      }
      let percentJoin = 0;
      for (let obj of this.activeJoinNames) {
        percentJoin += Number(obj.scale);
      }
      if (percentJoin != 100) {
        this.$toast("收益权重和一定要等于100");
        return;
      }

      this.WebNewAddInfo();
    },
    WebNewAddInfo() {
      let ItemLst = [];
      let ItemJoinLst = [];
      for (let obj of this.activeNames) {
        ItemLst.push({
          UserSysno: obj.id, //编号
          PayoutRatio: Number(obj.scale) //权重
        });
      }
      for (let obj of this.activeJoinNames) {
        ItemJoinLst.push({
          UserSysno: obj.id, //编号
          PayoutRatio: Number(obj.scale) //权重
        });
      }
      let data = {
        Item: {
          MasterUserSysno: localStorage.getItem("UserSysno"), //创建人编号
          ProName: this.proName, //项目名称
          ProType: this.proType == "月计划" ? 0 : 1, //项目类型
          ProALLMoney: this.proMoney, //项目金额
          PlanStartDate: this.startDate, //计划开始时间
          PlanOverTime: this.endDate, //计划完成时间
          ProSource: this.tag == "内部" ? 0 : 1, //项目标签 0内部 1外部
          ProRemark: this.proDesc, //项目描述
          Acceptance: this.activeId, //审核/验收人
          ProMoneyType: this.moneyType, //出资类型（0，全体人员；1部分人员；2外部）
          SourceUsersysno: ItemLst, //出资人员列表
          PartUsersysno: ItemJoinLst //收益人员列表
        }
      };
      if (this.$route.query.sysno) {
        data.Item.ProSysno = this.$route.query.sysno;
      }
      console.log(data);
      this.$baseajax.sliceRequest(
        this.$base.baseProject + "/WebNewAddInfo",
        data,
        res => {
          console.log(res);
          if (res.ResponseCode == 1) {
            this.$toast("已提交成功等待审核");
            this.$router.back();
          } else {
            this.$toast(res.ResponseMessage);
          }
        },
        err => {}
      );
    },
    // 切换出资人员tab
    onClickTab() {
      // 切换出资人员tab会将之前tab选中的人员等信息全部清除  并完成初始化
      // 将 activeIds 清空 将  activeIndex 置为 0   activeNames  tempActiveJoinNames 清空
      console.log("出资切换");
      this.activeIds = [];
      this.activeNames = [];
      this.tempActiveJoinNames = [];
      this.activeIndex = 0;
      return true;
    },
    // 切换收益人员tab
    onClickTab2() {
      // 切换出资人员tab会将之前tab选中的人员等信息全部清除  并完成初始化
      // 将 activeIds 清空 将  activeIndex 置为 0   activeNames  tempActiveJoinNames 清空
      console.log("收益切换");
      this.activeJoinIds = [];
      this.activeJoinNames = [];
      this.tempActiveJoinNames = [];
      this.activeJoinIndex = 0;
      return true;
    },
    WebAddInfo() {
      let data = {
        Item: {
          MasterUserSysno: localStorage.getItem("UserSysno"), //负责人编号
          // AllJoinPlanNumber: this.proNeddNum,//参与人数
          AllJoinPlanNumber: 2, //参与人数
          Item: {
            Item: {
              Name: this.proName
              // Sysno:''
            },
            PlanStartDate: this.startDate, //计划开始时间
            PlanOverTime: this.endDate, //计划完成时间
            ProALLMoney: this.proMoney, //项目金额
            ProRemark: this.proDesc, //项目描述
            ProSource: this.tag == "内部" ? 0 : 1, //项目标签 0内部 1外部
            AddproPlanType: this.proType == "月计划" ? 0 : 1, //项目类型
            ProType: {
              Sysno: this.proType == "月计划" ? 0 : 1
            }, //项目类别
            DepType: this.activeIds //参与部门
          }
        }
      };

      this.$baseajax.sliceRequest(
        this.$base.baseProject + "/WebAddInfo",
        data,
        res => {
          console.log(res);
          if (res.ResponseCode == 1) {
            this.$toast("添加成功");
            this.$router.back();
          } else {
            this.$toast(res.ResponseMessage);
          }
        },
        err => {}
      );
    },
    handleCloseDep() {
      this.activeName = [];
      for (let item of this.activeIds) {
        this.activeName.push({
          id: item
        });
      }
      for (let item2 of this.items[0].children) {
        this.activeName.map(item3 => {
          if (item3.id == item2.id) {
            item3.name = item2.text;
          }
          return item3;
        });
      }
    },
    onConfirmDep() {
      this.showDep = false;
    },

    onConfirmType(v) {
      this.proType = v;
      this.showType = false;
    },
    showMoney() {
      if (this.tag == "内部") {
        this.showMoneyType = true;
      }
    },
    onConfirmTag(v, i) {
      console.log("v", v);
      this.tag = v;
      this.showTag = false;

      //
      if (v == "内部") {
        this.moneyType = "1";
      } else {
        this.moneyType = "2";
      }
    },
    onConfirmStartTime(e) {
      let year = e.getFullYear();
      let month = e.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let day = e.getDate();
      day = day < 10 ? "0" + day : day;
      this.startDate = year + "-" + month + "-" + day;
      this.showStartTime = false;
    },
    onConfirmEndTime(e) {
      let year = e.getFullYear();
      let month = e.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let day = e.getDate();
      day = day < 10 ? "0" + day : day;
      this.endDate = year + "-" + month + "-" + day;
      this.showEndTime = false;
    },
    // 出资人员
    handleClose() {
      // 根据选择的tab来动态判断从哪个tab取值
      this.activeNames = [];
      for (let item of this.activeIds) {
        this.activeNames.push({
          id: item,
          scale: 0
        });
      }
      // 将已经填好的出资信息保存
      for (let item of this.tempActiveNames) {
        this.activeNames.map(item2 => {
          if (item2.id == item.id) {
            item2.scale = item.scale;
          }
          return item2;
        });
      }
      // 对应名字
      for (let item of this.personnellist) {
        for (let item2 of item.UItemList) {
          this.activeNames.map(item3 => {
            if (item3.id == item2.UserSysno) {
              item3.name = item2.UserName;
              item3.dep = item2.UserDepNameT;
            }
            return item3;
          });
        }
      }
      this.tempActiveNames = this.activeNames;
    },
    // 参与人员
    handleJoinClose() {
      this.activeJoinNames = [];
      for (let item of this.activeJoinIds) {
        this.activeJoinNames.push({
          id: item,
          scale: 0
        });
      }
      for (let item of this.tempActiveJoinNames) {
        this.activeJoinNames.map(item2 => {
          if (item2.id == item.id) {
            item2.scale = item.scale;
          }
          return item2;
        });
      }
      // 对应名字
      for (let item of this.personnellist) {
        for (let item2 of item.UItemList) {
          this.activeJoinNames.map(item3 => {
            if (item3.id == item2.UserSysno) {
              item3.name = item2.UserName;
              item3.dep = item2.UserDepNameT;
            }
            return item3;
          });
        }
      }
      this.tempActiveJoinNames = this.activeJoinNames;
    },
    // 验收人员
    handleTree(e) {
      this.activeNameOne = e.text;
    },

    // 获取部门信息
    WebGetBDepInfo() {
      let data = {
        page: 1,
        pcount: 100
      };
      this.$baseajax.normalJsonp(
        this.$base.baseEvent + "/WebGetBDepInfo",
        data,
        res => {
          console.log(res);
          res = res.WebGetBDepInfoResult;
          if (res.ResponseCode == 1) {
            for (let obj of res.ItemLst) {
              this.items.push({
                text: obj.DepInfo.Name,
                id: obj.DepInfo.Sysno,
                children: []
              });
            }
            // 获取人员列表
            this.WebGetItemLst();
          }
        },
        err => {}
      );
    },
    // 获取事业部信息
    WebGetUnitInfo() {
      let data = {
        page: 1,
        pcount: 100,
        SearchKey: ""
      };
      this.$baseajax.normalJsonp(
        this.$base.baseUnit + "/GetBusinessUnitList",
        data,
        res => {
          console.log(res);
          res = res.GetBusinessUnitListResult;
          if (res.ResponseCode == 1) {
            for (let obj of res.ItemLst) {
              this.itemsUnit.push({
                text: obj.BusinessUnit,
                id: obj.BusinessUnitSysno,
                children: []
              });
            }
            this.itemsUnit.push({
              text: "未分类",
              id: 0,
              children: []
            });
            // 获取事业部人员列表
            this.WebGetUnitItemLst();
          }
        },
        err => {}
      );
    },
    // 获取人员列表
    WebGetItemLst() {
      let data = {
        page: 1,
        pcount: 100
      };
      this.$baseajax.normalJsonp(
        this.$base.baseapi + "/WebGetItemLst",
        data,
        res => {
          console.log(res);
          res = res.WebGetItemLstResult;
          if (res.ResponseCode == 1) {
            for (let obj of res.ItemLst) {
              this.items.map(item2 => {
                if (obj.GovDepItem.Sysno == item2.id) {
                  item2.children.push({
                    text: obj.Item.Name,
                    id: obj.Item.Sysno
                  });
                }
                return item2;
              });
            }
            console.log(this.items);
          }
        },
        err => {}
      );
    },

    // 获取事业部人员列表
    WebGetUnitItemLst() {
      let data = {
        page: 1,
        pcount: 1000
      };
      this.$baseajax.normalJsonp(
        this.$base.baseapi + "/GetBusinessUnitUserList",
        data,
        res => {
          console.log(res);
          res = res.GetBusinessUnitUserListResult;
          if (res.ResponseCode == 1) {
            for (let obj of res.ItemLst) {
              this.itemsUnit.map(item2 => {
                if (obj.BusinessUnitItem.Sysno == item2.id) {
                  item2.children.push({
                    text: obj.userName,
                    id: obj.sysno
                  });
                }
                return item2;
              });
            }
            console.log(this.items);
          }
        },
        err => {}
      );
    },
    onConfirmMoneyType(v, i) {
      console.log(v, i);
      this.moneyType = i;
      this.showMoneyType = false;
    },
    //选择权重
    showWeightPicker(index, type) {
      this.showWeight = true;
      this.showWeightType = type;
      let v;
      if (type == "money") {
        this.weightActiveIndex = index;
        v = this.activeNames[this.weightActiveIndex].scale
          ? this.activeNames[this.weightActiveIndex].scale
          : 1;
      } else if (type == "join") {
        this.weightJoinActiveIndex = index;
        v = this.activeJoinNames[this.weightJoinActiveIndex].scale
          ? this.activeJoinNames[this.weightJoinActiveIndex].scale
          : 1;
      }
      this.$nextTick(() => {
        this.$refs.weight.setValues([v]);
      });
    },
    onConfirmWeight(v) {
      if (this.showWeightType == "money") {
        this.activeNames[this.weightActiveIndex].scale = v;
      } else if (this.showWeightType == "join") {
        this.activeJoinNames[this.weightJoinActiveIndex].scale = v;
      }
      this.showWeight = false;
    },

    // 项目详情
    WebGetDealProjectInfoEx(sysno) {
      let data = {
        DepSysno: sysno,
        UserId: localStorage.getItem("UserSysno")
      };
      this.$baseajax.normalJsonp(
        this.$base.baseProject + "/WebNewGetDealProjectInfoEx",
        data,
        res => {
          console.log(res);
          res = res.WebNewGetDealProjectInfoExResult;
          if (res.ResponseCode == 1) {
            let detailinfo = res.Item;
            this.proName = detailinfo.ProName;
            this.proType = detailinfo.ProType == 0 ? "月计划" : "临时计划";
            this.proMoney = detailinfo.ProALLMoney;
            this.tag = detailinfo.ProSource == 0 ? "内部" : "外部";
            this.startDate = detailinfo.PlanStartDate.split(" ")[0].replace(
              /\//g,
              "-"
            );
            this.endDate = detailinfo.PlanOverTime.split(" ")[0].replace(
              /\//g,
              "-"
            );
            this.proDesc = detailinfo.ProRemark;
            this.moneyType = detailinfo.ProMoneyType;
            this.activeId = detailinfo.Acceptance;
            this.activeNameOne = detailinfo.AcceptanceName;
            if (this.moneyType == 1) {
              for (let obj of detailinfo.SourceUsersysno) {
                this.activeNames.push({
                  id: obj.Usersysno, //编号
                  scale: parseInt(obj.PayoutRatio), //权重
                  name: obj.UserName
                });
                this.tempActiveNames.push({
                  id: obj.Usersysno,
                  scale: parseInt(obj.PayoutRatio),
                  name: obj.UserName
                });
                this.activeIds.push(obj.Usersysno);
              }
            }

            for (let obj of detailinfo.PartUsersysno) {
              this.activeJoinNames.push({
                id: obj.Usersysno, //编号
                scale: parseInt(obj.PayoutRatio), //权重
                name: obj.UserName
              });
              this.tempActiveJoinNames.push({
                id: obj.Usersysno,
                scale: parseInt(obj.PayoutRatio),
                name: obj.UserName
              });
              this.activeJoinIds.push(obj.Usersysno);
            }
          }
        },
        err => {}
      );
    },
    // 平均分配
    handleAverage(list, tempList) {
      let length = list.length;
      if (100 % length == 0) {
        list.map(item => {
          item.scale = 100 / length;
        });
      } else {
        let scale = Math.floor(100 / length);
        let lastScale = 100 - scale * (length - 1);
        list.map((item, index) => {
          if (index == length - 1) {
            item.scale = lastScale;
          } else {
            item.scale = scale;
          }
        });
      }
      tempList = list;
    },
    onshowMembers() {
      this.tableftindex = 0;
      this.toptabindex = -1;
      this.DItemList = this.personnellist[0].DItemList;
      this.UItemList = this.personnellist[0].UItemList;
      this.UItemList.forEach((element, index) => {
        if (this.activeIds.includes(element.UserSysno)) {
          element.flag = true;
        } else {
          element.flag = false;
        }
        this.$set(this.UItemList, index, element);
      });
      this.showMembers = true;
    },
    onshowJoinMembers() {
      this.tableftindex = 0;
      this.toptabindex = -1;
      this.DItemList = this.personnellist[0].DItemList;
      this.UItemList = this.personnellist[0].UItemList;
      this.UItemList.forEach((element, index) => {
        if (this.activeJoinIds.includes(element.UserSysno)) {
          element.isflag = true;
        } else {
          element.isflag = false;
        }
        this.$set(this.UItemList, index, element);
      });

      this.showJoinMembers = true;
    },
    // 公司人员获取
    WebGetNewUserInfo() {
      let data = {};
      this.$baseajax.normalJsonp(
        this.$base.baseapi + "/WebGetNewUserInfo",
        data,
        res => {
          console.log(res, "@@@@@@");
          if (res.WebGetNewUserInfoResult.ResponseCode == 1) {
            this.personnellist = res.WebGetNewUserInfoResult.ItemLst;
            this.DItemList = res.WebGetNewUserInfoResult.ItemLst[0].DItemList;
            this.UItemList = this.personnellist[0].UItemList;
          }
        },
        err => {}
      );
    },
    onpersonnellist(index) {
      this.tableftindex = index;
      this.toptabindex = -1;
      this.DItemList = this.personnellist[index].DItemList;
      this.UItemList = this.personnellist[index].UItemList;
      this.UItemList.forEach((element, index) => {
        if (this.activeIds.includes(element.UserSysno)) {
          element.flag = true;
        } else {
          element.flag = false;
        }
        this.$set(this.UItemList, index, element);
      });
      this.UItemList.forEach((element, index) => {
        if (this.activeJoinIds.includes(element.UserSysno)) {
          element.isflag = true;
        } else {
          element.isflag = false;
        }
        this.$set(this.UItemList, index, element);
      });
      console.log(this.DItemList);
    },
    onDItemList(index) {
      this.toptabindex = index;
      if (index == -1) {
        this.UItemList = this.personnellist[this.tableftindex].UItemList;
      } else {
        this.UItemList = this.DItemList[index].UItemList;
      }
      this.UItemList.forEach((element, index) => {
        if (this.activeIds.includes(element.UserSysno)) {
          element.flag = true;
        } else {
          element.flag = false;
        }
        this.$set(this.UItemList, index, element);
      });
      this.UItemList.forEach((element, index) => {
        if (this.activeJoinIds.includes(element.UserSysno)) {
          element.isflag = true;
        } else {
          element.isflag = false;
        }
        this.$set(this.UItemList, index, element);
      });
    },
    // 选择验收人员
    onUserName(item) {
      this.activeId = item.UserSysno;
      console.log(this.activeId);
      this.activeNameOne = item.UserName;
    },
    // 出资人员
    onUserName1(item, index) {
      let bol = this.activeIds.some(i => {
        if (i == item.UserSysno) {
          return true;
        }
      });
      if (!bol) {
        this.activeIds.push(item.UserSysno);
        // item.flag = true
      } else {
        var new_set = new Set(this.activeIds);
        new_set.delete(item.UserSysno);
        this.activeIds = [...new_set];
        // item.flag = false
      }
      this.personnellist.map(it => {
        it.UItemList.map((i, index) => {
          if (i.UserSysno == item.UserSysno) {
            if (!bol) {
              i.flag = true;
            } else {
              i.flag = false;
            }
            this.$set(it.UItemList, index, i);
          }
        });
        it.DItemList.map(its => {
          its.UItemList.map((list, index) => {
            if (list.UserSysno == item.UserSysno) {
              if (!bol) {
                list.flag = true;
              } else {
                list.flag = false;
              }
              this.$set(its.UItemList, index, list);
            }
          });
        });
      });
      // this.$set(this.UItemList, index, item)
    },
    // activeJoinId受益人员3
    onUserName2(item, index) {
      let bol = this.activeJoinIds.some(i => {
        if (i == item.UserSysno) {
          return true;
        }
      });
      if (!bol) {
        this.activeJoinIds.push(item.UserSysno);
        // item.isflag = true
      } else {
        var new_set = new Set(this.activeJoinIds);
        new_set.delete(item.UserSysno);
        this.activeJoinIds = [...new_set];
        // item.isflag = false
      }
      this.personnellist.map(it => {
        it.UItemList.map((i, index) => {
          if (i.UserSysno == item.UserSysno) {
            if (!bol) {
              i.isflag = true;
            } else {
              i.isflag = false;
            }
            this.$set(it.UItemList, index, i);
          }
        });
        it.DItemList.map(its => {
          its.UItemList.map((list, index) => {
            if (list.UserSysno == item.UserSysno) {
              if (!bol) {
                list.isflag = true;
              } else {
                list.isflag = false;
              }
              this.$set(its.UItemList, index, list);
            }
          });
        });
      });
    }
  },
  beforeCreate() {
    document.querySelector("body").className = "fff";
  },
  destroyed() {
    document.querySelector("body").className = "";
  }
};
</script>

<style lang="less" scoped>
.average-wrap {
  margin-top: 0.2rem;
  display: flex;
  justify-content: flex-end;
}

.average-btn {
  width: 2rem;
  height: 0.7rem;
  line-height: 0.7rem;
  font-size: 0.3rem;
  color: #fff;
  background: #D32F2F;
  border-radius: 0.7rem;
}

.sticky-tab {
  box-shadow: 0rem 0.01rem 0.13rem 0rem rgb(42 48 158 / 11%);
}

.tab-income-outgo-wrap {
  display: flex;
  background: #f6f6f6;
  height: 1.2rem;
  line-height: 1.2rem;
  padding: 0 0.28rem;

  .item {
    width: 3rem;
    font-size: 0.42rem;
    color: #333;

    &.active {
      color: #D32F2Fff;
    }
  }
}

.page-info-wrap {
  padding: 0.28rem;

  .item {
    padding: 0.5rem 0;
    border-bottom: 1px solid #eee;
    font-size: 0.37rem;
    color: #666666;
    display: flex;
    justify-content: space-between;
    align-items: center;

    /deep/.van-uploader {
      // background: #eee;
      border-radius: 100%;
      opacity: 0;
      margin: 0;
      position: absolute;
      top: 0;
      left: 0;
    }

    /deep/.van-uploader__upload {
      width: 1.47rem;
      height: 1.47rem;
      margin: 0;
    }

    .img-wrap {
      position: relative;
      background: #eee;
      border-radius: 100%;
      overflow: hidden;

      img {
        display: block;
        width: 1.47rem;
        height: 1.47rem;
      }
    }

    span {
      color: #333333;
    }

    .input {
      text-align: right;
      font-size: 0.37rem;
      color: #666666;
      width: 60%;
    }

    .textarea {
      width: 100%;
      margin-top: 0.4rem;
      display: block;
      padding: 0.2rem 0.3rem;
      height: 3rem;
      background-color: #f0f0f0;
      border-radius: 0.13rem;
      font-size: 0.37rem;
      color: #666666;
    }

    &.arr {
      position: relative;
      padding-right: 0.3rem;

      &:after {
        display: block;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -0.1rem;
        content: "";
        width: 0.2rem;
        height: 0.2rem;
        border-top: 1px solid #999999;
        border-left: 1px solid #999999;
        transform: rotate(135deg);
      }
    }
  }
}

/deep/.van-tree-select__nav {
  // display: none;
}

.submit-btn {
  // position: fixed;
  // bottom: 0.3rem;
  // left: 0.6rem;
  margin: 1rem auto 0.5rem;
  width: 8.8rem;
  height: 1.04rem;
  line-height: 1.04rem;
  background-color: #D32F2F;
  box-shadow: 0rem 1px 0.09rem 0rem rgba(26, 26, 26, 0.29);
  border-radius: 0.2rem;
  text-align: center;
  font-size: 0.47rem;
  color: #ffffff;
}

/deep/.van-overlay {
  background-color: rgba(0, 0, 0, 0.5);
}

.gc-page-project-wrap {
  .page-dep-wrap {
    .item {
      display: flex;
      justify-content: space-between;
      position: relative;

      &.arr {
        padding-right: 0.3rem;

        &:after {
          display: block;
          position: absolute;
          right: 0;
          top: 50%;
          margin-top: -0.1rem;
          content: "";
          width: 0.2rem;
          height: 0.2rem;
          border-top: 0.02667rem solid #999999;
          border-left: 0.02667rem solid #999999;
          -webkit-transform: rotate(135deg);
          transform: rotate(135deg);
        }
      }
    }
  }

  .page-member-wrap {
    margin-right: 0;
    padding-right: 0;
    padding-top: 0.1rem;
  }

  .review-btn .btn.dis {
    background: #ddd;
    border-color: #ddd;
  }
}

.page-member-wrap {
  margin-right: 0;
  padding-right: 0;
  padding-top: 0.1rem;
}

.review-btn .btn.dis {
  background: #ddd;
  border-color: #ddd;
}

.warp {
  height: 100%;
  position: relative;
}

.opt-btn {
  display: flex;
  height: 10%;
  font-size: 0.34rem;
  justify-content: space-between;
  padding: 0.25rem;
  position: sticky;
  // background: #fcfcfc;
  border-bottom: 1px solid #f5f5f5;

  .sure {
    color: #ee0a24;
  }
}

.popupbottom {
  display: flex;
  height: 90%;
  overflow: hidden;

  .popupbottom-left {
    width: 30%;
    overflow-y: scroll;
    background: #f5f5f5;

    .popupbottom-tab {
      height: 1.5rem;
      line-height: 1.5rem;
      font-size: 0.4rem;
      text-align: center;
      background: #f5f5f5;
      border-left: 5px solid #f5f5f5;
    }

    .active {
      height: 1.5rem;
      line-height: 1.5rem;
      font-size: 0.4rem;
      text-align: center;
      background: #fff;
      border-left: 5px solid red;
    }
  }

  .popupbottom-right {
    width: 70%;
    height: 100%;
    position: relative;

    .popupbottom-tab2 {
      width: 100%;
      height: 10%;
      white-space: nowrap;
      display: flex;
      overflow-x: scroll;
      position: sticky;
      top: 0;
      background: #f8f8f8;

      .tab2-center {
        text-align: center;
        line-height: 1rem;
        font-size: 0.3rem;
        padding: 0 20px;
        background: #f8f8f8;
        border-bottom: 3px solid #f8f8f8;
      }

      .active {
        text-align: center;
        line-height: 1rem;
        font-size: 0.3rem;
        padding: 0 20px;
        background: #fff;
        border-bottom: 3px solid red;
      }
    }

    .popupbottom-list {
      height: 90%;
      overflow-y: scroll;

      div {
        width: 100%;
        font-size: 0.4rem;
        text-align: center;
        height: 1rem;
        line-height: 1rem;
      }

      .active {
        width: 100%;
        font-size: 0.4rem;
        text-align: center;
        height: 1rem;
        line-height: 1rem;
        color: red;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/add/AddProject.vue